import React, { useEffect, useState } from "react";
import SidebarHeaderLayout from "../../HOC/SidebarHeaderLayout";

import { createEvent } from "../../../api-core/Events";
import {
  createHotel,
  createHotelRoom,
  createHotelRoomChecklist,
  getAllHotel,
  getAllHotelRoomType,
} from "../../../api-core/Hotel";
const CreateHotelRoomChecklist = () => {
  const [hotels, setHotels] = useState([]);
  const [roomTypeId, setRoomTypeId] = useState([]);
  const [inputs, setInputs] = useState({
    hotel_id: "",
    room_type_id: "",
    checklist_name: "",
  });
  useEffect(() => {
    const fetchAllHotel = async () => {
      const res = await getAllHotel();
      setHotels(res.hotel);
    };
    fetchAllHotel();
  }, []);

  useEffect(() => {
    const fetchAllRoomTypeId = async () => {
      const res = await getAllHotelRoomType();
      setRoomTypeId(res.hotelroomtype);
    };
    fetchAllRoomTypeId();
  }, []);
  // console.log("roomTypeId", roomTypeId);
  const handleChange = (e) => {
    setInputs({
      ...inputs,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("inputs", inputs);

    if (inputs) {
      const res = await createHotelRoomChecklist(inputs);
      console.log("resHotelRoom", res);
    } else {
      console.log("error");
    }
  };
  return (
    <div className="w-[90%] mx-auto ">
      <h1>Create Hotel Room Checklist</h1>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="flex flex-col justify-center items-center  md:justify-between md:flex-row gap-x-5 flex-wrap">
          <div className="mb-6 w-[95%] md:w-[45%] ">
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
              Hotel Id
            </label>
            <select
              value={inputs.hotel_id}
              name="hotel_id"
              onChange={handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              {hotels.map((value) => (
                <option value={value._id} key={value._id}>
                  {value.hotel_name}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-6 w-[95%] md:w-[45%] ">
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
              Room Type Id
            </label>
            <select
              value={inputs.room_type_id}
              name="room_type_id"
              onChange={handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              {roomTypeId.map((value) => (
                <option value={value._id} key={value._id}>
                  {value.room_type_name}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-6 w-[95%] md:w-[45%] ">
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
              Checklist Name
            </label>
            <input
              type="text"
              name="checklist_name"
              value={inputs.checklist_name}
              onChange={handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="enter Checklist Name"
            />
          </div>
        </div>
        <button
          type="submit"
          className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-[50%] sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default SidebarHeaderLayout(CreateHotelRoomChecklist);
